import { render, staticRenderFns } from "./addLinks.vue?vue&type=template&id=2b648144&"
import script from "./addLinks.vue?vue&type=script&lang=js&"
export * from "./addLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b648144')) {
      api.createRecord('2b648144', component.options)
    } else {
      api.reload('2b648144', component.options)
    }
    module.hot.accept("./addLinks.vue?vue&type=template&id=2b648144&", function () {
      api.rerender('2b648144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addLinks.vue"
export default component.exports